import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ArticleTemplate, defaultArticleTemplate } from "../../models/responses/articleTemplate";

function interpretAsDecimal(input: number): number {
  const value = input.toString();
  const beforeComma = value.slice(0, value.length - 2) || "0";
  const afterComma = value.slice(value.length - 2, value.length) || "00";
  return parseFloat(`${beforeComma}.${afterComma}`);
}

function formatSalesPrice(price: string | number): string {
  const num = typeof price === "string" ? parseFloat(price) : price;
  if (isNaN(num)) return "0.00";
  if (Number.isInteger(num)) {
    return interpretAsDecimal(num).toFixed(2);
  }
  return num.toFixed(2);
}


export interface ArticleTemplateState {
    articleTemplateList: ArticleTemplate[];
    articleTemplateListTime: ArticleTemplate[];
    articleTemplateListProduct: ArticleTemplate[];
    articleTemplate: ArticleTemplate;
    isWaitingArticleTemplatePostResponse: boolean;
    isWaitingArticleTemplatePutResponse: boolean;    
    totalQueryArticleTemplate: number;
    isWaitingArticleTemplateGetResponse: boolean;
    filteredArticleTemplateList: ArticleTemplate[];
}

const initialState: ArticleTemplateState = {
    articleTemplateList: [],
    articleTemplateListTime: [],
    articleTemplateListProduct: [],
    articleTemplate: { ...defaultArticleTemplate },
    isWaitingArticleTemplatePostResponse: false,
    isWaitingArticleTemplatePutResponse: false,
    isWaitingArticleTemplateGetResponse: false,    
    totalQueryArticleTemplate: 0,
    filteredArticleTemplateList: [],
};

const articleTemplateSlice = createSlice({
    name: 'articleTemplate',
    initialState,
    reducers: {
                setArticleTemplateList: (state, action: PayloadAction<{
                        articleTemplates: ArticleTemplate[];
                }>) => {
                        state.articleTemplateList = (action.payload.articleTemplates || initialState.articleTemplateList)
                            .map(at => ({
                                ...at,
                                salesPrice: formatSalesPrice(at.salesPrice)
                            }));
                        return state;
                },
                setArticleTemplateListTime: (state, action: PayloadAction<{ articleTemplates: ArticleTemplate[] }>) => {
                        state.articleTemplateListTime = (action.payload.articleTemplates || []).map(at => ({
                                ...at,
                                salesPrice: formatSalesPrice(at.salesPrice)
                        }));
                        return state;
                },
                setArticleTemplateListProduct: (state, action: PayloadAction<{ articleTemplates: ArticleTemplate[] }>) => {
                        state.articleTemplateListProduct = (action.payload.articleTemplates || []).map(at => ({
                                ...at,
                                salesPrice: formatSalesPrice(at.salesPrice)
                        }));
                        return state;
                },
        setArticleTemplate: (state, action: PayloadAction<{
            articleTemplate: ArticleTemplate;
        }>) => {
            const at = action.payload.articleTemplate;
            state.articleTemplate = {
                ...at,
                salesPrice: formatSalesPrice(at.salesPrice)
            };
            return state;
        },
        setIsWaitingArticleTemplatePostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleTemplatePostResponse = action.payload;
        },
        setIsWaitingArticleTemplatePutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleTemplatePutResponse = action.payload;
        },
        setIsWaitingArticleTemplateGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleTemplateGetResponse = action.payload;
        },
        setFilteredArticleTemplateList: (state, action: PayloadAction<{ articleTemplates: ArticleTemplate[] }>) => {
            state.filteredArticleTemplateList = (action.payload.articleTemplates || []).map(at => ({
                ...at,
                salesPrice: formatSalesPrice(at.salesPrice)
            }));
            return state;
        }
    },
});


export const {
    setArticleTemplateList,
    setArticleTemplateListTime,
    setArticleTemplateListProduct,
    setArticleTemplate,
    setIsWaitingArticleTemplatePostResponse,
    setIsWaitingArticleTemplatePutResponse,
    setIsWaitingArticleTemplateGetResponse,    
    setFilteredArticleTemplateList,
} = articleTemplateSlice.actions;

export default articleTemplateSlice.reducer;